import { Component, computed, EventEmitter, input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'

import { ReportingPeriodWithStatus } from '../../models/questionnaire.model'

type ReportingPeriodStatus = ReportingPeriodWithStatus['status']

const NOT_STARTED_STATUS: ReportingPeriodStatus = 'not_started'

const STATUS_LABELS: Record<ReportingPeriodStatus, string> = {
  not_started: 'Not started',
  draft: 'Draft',
  pending_review: 'Pending review',
  unchanged: 'Unchanged',
  published: 'Published'
}

@Component({
  selector: 'app-reporting-periods-list',
  templateUrl: './reporting-periods-list.component.html',
  styleUrls: ['./reporting-periods-list.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class ReportingPeriodsListComponent {
  readonly $periods = input<ReportingPeriodWithStatus[]>([])
  readonly $profileIncomplete = input(false)
  @Output() selectPeriod = new EventEmitter<ReportingPeriodWithStatus>()

  readonly notStartedStatus = NOT_STARTED_STATUS
  readonly statusLabels = STATUS_LABELS

  readonly $periodsByYear = computed(() => {
    const groups = new Map<number, ReportingPeriodWithStatus[]>()
    for (const period of this.$periods()) {
      const list = groups.get(period.year) || []
      list.push(period)
      groups.set(period.year, list)
    }
    return Array.from(groups, ([year, periods]) => ({ year, periods }))
      .sort((a, b) => b.year - a.year)
  })

  onSelect(period: ReportingPeriodWithStatus): void {
    this.selectPeriod.emit(period)
  }
}
